export default "__VITE_ASSET__EiwXMrge__"